import { render, staticRenderFns } from "./TaskNode.vue?vue&type=template&id=2f69ae0c"
import script from "./TaskNode.vue?vue&type=script&lang=js"
export * from "./TaskNode.vue?vue&type=script&lang=js"
import style0 from "./TaskNode.vue?vue&type=style&index=0&id=2f69ae0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports